export default {"src":"/_next/static/media/highlightlive.ff1b0387.svg","height":180,"width":284};